import React from 'react';
import Hero from './components/administration/deans/Hero';
import Main from './components/administration/deans/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Deans = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default Deans;